// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HmKwpN_whDdyxadRB704{padding:0;overflow-x:hidden;overflow-y:auto}.UG61zfm_TTktx9dJA8Rf{flex-direction:column;flex:1;justify-content:center;width:100%;max-width:100%;margin:0 auto;padding:0 16px;display:flex}.UG61zfm_TTktx9dJA8Rf.oUR0Ppeq0h_IIFo0kjwQ{justify-content:flex-start}.hZhdvZDyycKNB6rPgQcV{padding:10px}.JZfWi1B3c1QdeQDVDDAB{flex-direction:column;align-items:center;display:flex}.aqb5wQkZ7Q8CXAouF6GB [aria-label=DefaultModal_HeaderTitle]{white-space:nowrap;text-overflow:ellipsis;max-width:930px;display:block;overflow:hidden}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `HmKwpN_whDdyxadRB704`,
	"content": `UG61zfm_TTktx9dJA8Rf`,
	"isEmptyContent": `oUR0Ppeq0h_IIFo0kjwQ`,
	"dropZoneContainer": `hZhdvZDyycKNB6rPgQcV`,
	"dropZoneInfo": `JZfWi1B3c1QdeQDVDDAB`,
	"modalWrapper": `aqb5wQkZ7Q8CXAouF6GB`
};
export default ___CSS_LOADER_EXPORT___;
